import { Typography, Slider } from '@mui/material';
import { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { Button } from '@design-system/components/button/button';
import { faArrowRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sprinkles } from '@design-system/sprinkles.css';
import { wrapper } from './SelectThumbnail.css';

export type VideoView = {
  url: string;
  downloadUrl?: string;
  thumbnailUrl: string;
  width: number;
  height: number;
  duration: number;
  isMux: boolean;
};

type VideoThumbnailSelect = {
  video: VideoView;
  onChange: (timeInSeconds: number) => void;
  onRestore: () => void;
  submitting: boolean;
};

const SHORT_VIDEO_BREAKPOINT = 90;

function SelectThumbnail(p: VideoThumbnailSelect) {
  const playerRef = useRef<ReactPlayer>(null);
  const [metadata, setMetadata] = useState({
    duration: p.video.duration,
  });
  const [sliderValue, setSliderValue] = useState(0);

  const handleSliderChange = (
    _event: Event | null,
    newValue: number | number[],
  ) => {
    const value = newValue as number;
    setSliderValue(value);
    if (playerRef?.current) {
      playerRef.current.seekTo(value);
    }
  };

  const saveThumbnail = () => {
    p.onChange(sliderValue);
  };

  const isMuxVideo = p.video.isMux;
  const thumbnailUrl = p.video.thumbnailUrl;

  return (
    <div className={wrapper}>
      {isMuxVideo && p.video?.duration > SHORT_VIDEO_BREAKPOINT ? (
        <>
          <img
            src={`${thumbnailUrl}?smart_crop=true&time=${sliderValue}`}
            className="max-w-full max-h-[372px] object-contain"
          />
        </>
      ) : (
        <div className="flex justify-center bg-black">
          <ReactPlayer
            onDuration={(duration) => setMetadata({ duration })}
            ref={playerRef}
            playing={false}
            seconds={sliderValue}
            playsinline
            height={300}
            url={p.video.url}
            style={{
              borderRadius: '6px',
              overflow: 'hidden',
            }}
          />
        </div>
      )}
      <div className="mt-5">
        <Typography variant="h5" className="font-semibold">
          Use slider to select the frame for the thumbnail.
        </Typography>
      </div>
      <Slider
        value={sliderValue}
        max={metadata.duration}
        step={0.01}
        onChange={handleSliderChange}
      />
      <div
        className={sprinkles({
          display: 'flex',
          alignItems: 'center',
          gap: 'm',
          justifyContent: 'end',
        })}
      >
        <Button
          variant="text"
          color="neutral"
          onClick={p.onRestore}
          disabled={p.submitting}
        >
          <div
            className={sprinkles({
              display: 'flex',
              alignItems: 'center',
              gap: 'm',
            })}
          >
            <FontAwesomeIcon icon={faArrowRotateLeft} /> Restore changes
          </div>
        </Button>
        <Button
          onClick={saveThumbnail}
          color="primaryTonal"
          disabled={p.submitting}
        >
          Select thumbnail
        </Button>
      </div>
    </div>
  );
}

export default SelectThumbnail;
